import { Component } from '@angular/core';

@Component({
  selector: 'app-pre-loader',
  imports: [],
  templateUrl: './pre-loader.html',
  styleUrl: './pre-loader.scss'
})
export class PreLoader {

}
